import loadable from '@loadable/component';

export const CountrylifeSiteWrapper = loadable(
  () => import(/* webpackChunkName: "countrylife-site" */ './CountrylifeSiteWrapper'),
);
